import { AttachmentModel } from '@/features/attachment/_models/attachment';
import { z } from 'zod';

export const FileEntryModel = z.object({
  file: z.instanceof(File).nullable(),
  attachment: AttachmentModel.nullable(),
  url: z.string(),
});

export type FileEntry = z.infer<typeof FileEntryModel>;
